<template>
    <div :class="['assembled-product', {'blurred': isOverlayVisible}, ...assembledProductClass]"
        :style="{...assembledProductStyle, ...inlineStyle}"
        v-show="isVisible">
        <button v-if="shouldShowBackButton"
            type="button"
            :class="['icon-arrow3--left', 'restart-button', 'fixed']"
            @click="onClickBack()">
            <span class="sr-only">Move back</span>
        </button>
        <image-layer wrapperClass="layer" :image="assembledImage" :shouldUpdateImage="true"></image-layer>
        <span class="fragrance-label">
            {{fragranceLabel}}
        </span>
    </div>
</template>

<script src="./assembled-product.js"></script>
